export default "__VITE_ASSET__CjXvDKO0__"